import { useCallback, useEffect, useState , useRef } from "react";

import { LONG_PRESS_TIME_DEFAULT } from "../utils/constants";

// eslint-disable-next-line no-empty-function
const useLongPress = (callback = () => {}, ms = LONG_PRESS_TIME_DEFAULT) => {
  const [startLongPress, setStartLongPress] = useState(false);
  const callbackRef = useRef(callback);

  // Update the ref to the latest callback function
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    let timerId: NodeJS.Timeout | null = null;

    if (startLongPress) {
      // Use callbackRef.current to ensure latest function is called
      timerId = setTimeout(() => {
        if (typeof callbackRef.current === "function") {
          callbackRef.current(); // Call the most up-to-date callback
        }
      }, ms);
    }

    return () => {
      if (timerId) {
        clearTimeout(timerId); // Cleanup timer
      }
    };
  }, [ms, startLongPress]);

  const start = useCallback(() => {
    setStartLongPress(true);
  }, []);

  const stop = useCallback(() => {
    setStartLongPress(false);
  }, []);

  return {
    triggerLongPressManually: start,
    stopLongPressManually: stop,
    onPointerDown: start,
    onPointerUp: stop,
    onPointerLeave: stop,
    onTouchStart: start,
    onTouchEnd: stop,
  };
};

export default useLongPress;
